import { render, staticRenderFns } from "./claimIndemnity.vue?vue&type=template&id=1e64aaae&scoped=true&"
import script from "./claimIndemnity.vue?vue&type=script&lang=js&"
export * from "./claimIndemnity.vue?vue&type=script&lang=js&"
import style0 from "./claimIndemnity.vue?vue&type=style&index=0&id=1e64aaae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e64aaae",
  null
  
)

export default component.exports